import { render } from "./Home.vue?vue&type=template&id=b9853efe&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b9853efe&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9853efe"]])

export default __exports__